module.exports = __webpack_public_path__ + "static/img/noexam.d2607c9e.png";